import axios from 'axios';
export const fetchHighlightedReviews = async ({
  baseUrl,
  hotelId,
  language: lang
}) => {
  return axios.get(`${baseUrl}/v1/reviews/highlighted/${hotelId}`, {
    params: {
      lang
    }
  }).then(({
    data
  }) => data).catch(() => undefined);
};